/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/11/2021
 */
import mergeProps from "@/router/utils/mergeProps";
import redirectByName from "@/router/utils/redirectByName.js";

let EmptyRouterView = () => import(/* webpackChunkName: "ClientsModule" */ '@/core/components/EmptyRouterView.vue')
let ClientDetailsMain = () => import(/* webpackChunkName: "ClientsModule" */ '@/core/recoveryCoachingApp/coach/clients/ClientDetails/ClientDetailsMain.vue')


export default [

	{
		path: ':clientProfileId/details',
		name: 'ClientDetailsMain',
		redirect: redirectByName('ClientDetailsMainTabs', {activeTab: 'first-tab'}),
		component: EmptyRouterView,
		props: mergeProps,
		children: [

			{
				path: ':activeTab/:packageId',
				name: 'ClientDetailsPackages',
				component: ClientDetailsMain,
				props: route => ({
					...mergeProps(route),
					responseParam: route.query.res,
					activeTab: 'packages',
				}),

			},
			{
				path: ':activeTab',
				name: 'ClientDetailsMainTabs',
				component: ClientDetailsMain,
				props: route => ({
					...mergeProps(route),
					responseParam: route.query.res
				}),

			},


			{
				path: '',
				name: 'ClientDetailsMainSessions',
				redirect: redirectByName('ClientDetailsMainTabs', {activeTab: 'sessions'}),
			},
			{
				path: '',
				name: 'ClientDetailsMainGenogram',
				redirect: redirectByName('ClientDetailsMainTabs', {activeTab: 'genogram'}),
			},

		],
	},






]


